export const dashboardPagesMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/',
		icon: 'Dashboard',
		subMenu: null,
	},
	businessProfile: {
		id: 'business-profile',
		text: 'Business Profile',
		path: '/profile',
		icon: 'Store',
		subMenu: null,
	},
	campaigns: {
		id: 'campaigns',
		text: 'Campaigns',
		path: '/campaigns',
		icon: 'Campaign',
		subMenu: null,
	},
	notifications: {
		id: 'customer-management',
		text: 'CustomerManagement',
		path: '/customer-management',
		icon: 'ManageAccounts',
		subMenu: null,
	},
	flyerGenerator: {
		id: 'flyer-generator',
		text: 'FlyerGenerator',
		path: '/flyer-generator',
		icon: 'BrandingWatermark',
		subMenu: null,
	},
	menuManagement: {
		id: 'menu-management',
		text: 'MenuManagement',
		path: '/menu-management',
		icon: 'RestaurantMenu',
		subMenu: null,
	},
};

export const adminPagesMenu = {
	admin: {
		id: 'admin',
		text: 'Admin',
		icon: 'AdminPanelSettingsIcon',
	},
	adminDashboard: {
		id: 'admin-dashboard',
		text: 'Admin Dashboard',
		path: '/admin-dashboard',
		icon: 'Dashboard',
		subMenu: null,
	},
	businessDashboard: {
		id: 'business-dashboard',
		text: 'Business Dashboard',
		path: '/business-dashboard',
		icon: 'GridView',
		subMenu: null,
	},
	businessManagement: {
		id: 'business-management',
		text: 'Business Management',
		path: '/business-management',
		icon: 'AddBusiness',
		subMenu: null,
	},
	staffManagement: {
		id: 'staff-management',
		text: 'Staff Management',
		path: '/staff-management',
		icon: 'GroupAdd',
		subMenu: null,
	},
	campaignManagement: {
		id: 'campaign-management',
		text: 'Campaign Management',
		path: '/campaign-management',
		icon: 'Campaign',
		subMenu: null,
	},
	notificationManagement: {
		id: 'customer-management',
		text: 'CustomerManagement',
		path: '/customer-management',
		icon: 'ManageAccounts',
		subMenu: null,
	},
	flyerGenerator: {
		id: 'flyer-generator',
		text: 'FlyerGenerator',
		path: '/flyer-generator',
		icon: 'BrandingWatermark',
		subMenu: null,
	},
};

export const authPagesMenu = {
	auth: {
		id: 'auth',
		text: 'Auth Pages',
		icon: 'Extension',
	},
	login: {
		id: 'login',
		text: 'Login',
		path: 'auth-pages/login',
		icon: 'Login',
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: 'auth-pages/sign-up',
		icon: 'PersonAdd',
	},
	forgotPassword: {
		id: 'forgotPassword',
		text: 'Forgot Password',
		path: 'auth-pages/forgot-password',
		icon: 'Password',
	},
	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: 'layoutTypes',
		text: 'Page Layout Types',
	},
	blank: {
		id: 'blank',
		text: 'Blank',
		path: 'page-layouts/blank',
		icon: 'check_box_outline_blank ',
	},
	pageLayout: {
		id: 'pageLayout',
		text: 'Page Layout',
		path: 'page-layouts',
		icon: 'BackupTable',
		subMenu: {
			headerAndSubheader: {
				id: 'headerAndSubheader',
				text: 'Header & Subheader',
				path: 'page-layouts/header-and-subheader',
				icon: 'ViewAgenda',
			},
			onlyHeader: {
				id: 'onlyHeader',
				text: 'Only Header',
				path: 'page-layouts/only-header',
				icon: 'ViewStream',
			},
			onlySubheader: {
				id: 'onlySubheader',
				text: 'Only Subheader',
				path: 'page-layouts/only-subheader',
				icon: 'ViewStream',
			},
			onlyContent: {
				id: 'onlyContent',
				text: 'Only Content',
				path: 'page-layouts/only-content',
				icon: 'WebAsset',
			},
		},
	},
	asideTypes: {
		id: 'asideTypes',
		text: 'Aside Types',
		path: 'aside-types',
		icon: 'Vertical Split',
		subMenu: {
			defaultAside: {
				id: 'defaultAside',
				text: 'Default Aside',
				path: 'aside-types/default-aside',
				icon: 'ViewQuilt',
			},
			minimizeAside: {
				id: 'minimizeAside',
				text: 'Minimize Aside',
				path: 'aside-types/minimize-aside',
				icon: 'View Compact',
			},
		},
	},
};
